// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1pkNu","item":"PaymentsMobile_item__M2Vyo","label":"PaymentsMobile_label__28iPk","amount":"PaymentsMobile_amount__2PlbZ"};